<ng-container *ngIf="isEditModeEnabled || note.text || note?.gif?.id">
  <div class="sp-py-4 type-and-buttons" [class.remove-mode]="note.text || editingStatus || note?.gif?.id">
    <span *ngIf="note.text" [attr.aria-label]="note.type" [class]="'type ' + note.type" tabindex="0">{{ "reflections_overview_" + note.type | localize | titlecase }}</span>
    <span *ngIf="!note.text" [attr.aria-label]="note.type" [class]="'type ' + note.type" [class.no-note]="!editingStatus" (click)="changeEditingStatus({ status: true })" tabindex="0">{{
      "reflections_overview_" + note.type | localize | titlecase
    }}</span>
    <ng-container *ngIf="isEditModeEnabled">
      <div *ngIf="!note.text && !editingStatus && !note?.gif?.id" [attr.aria-label]="'Add ' + note.type" (keydown.enter)="changeEditingStatus({ status: true })" tabindex="0">
        <i
          class="sp-mr-8 sp-ml-8 fs-12px text-color-primary-8 add"
          [attr.data-test-id]="'check-in-note-' + note.type + '-add-btn'"
          (click)="changeEditingStatus({ status: true })"
          ui-icon
          uiType="plus"></i>
      </div>
    </ng-container>
  </div>
  <div class="editor-container">
    <div *ngIf="note.text || editingStatus || note?.gif?.id" [class]="'editor ' + (!isEditModeEnabled && note.type)" [class.border-read-only]="!isEditModeEnabled">
      <rich-text-editor
        [team]="team"
        [teams]="teams"
        [isOKRLinkSelectorEnabled]="true"
        [a11yLabel]="a11yLabel"
        [gif]="note.gif"
        [autofocus]="true"
        [focusOnEditable]="false"
        [contentOnly]="!isEditModeEnabled"
        [hidePostButton]="true"
        [hideToolbarWhenUnfocused]="true"
        [text]="note.text"
        [placeholder]="'your_note' | localize"
        (textChange)="updateNote($event)"
        (editorFocus)="changeEditingStatus({ status: true })"
        (editorBlur)="removeDefaultText()"
        (gifChange)="gifChange($event)"
        (okrLinkClick)="okrLinkClick.emit($event)"
        tabindex="0"></rich-text-editor>
    </div>
    <button
      class="sp-ml-8"
      *ngIf="isEditModeEnabled && (note.text || editingStatus || note?.gif?.id)"
      [attr.aria-label]="'Delete ' + note.type + ' note'"
      (click)="removeNote()"
      (keydown.enter)="removeNote()"
      ui-button
      tabindex="0">
      <i class="sp-p-8 fs-15px text-color-gray-9 remove" [attr.data-test-id]="'check-in-note-' + note.type + '-delete-btn'" ui-icon uiType="trash-bin"></i>
    </button>
  </div>
</ng-container>
<div *ngIf="note?.gif?.id && !isEditModeEnabled" [class]="[!isEditModeEnabled && 'border-read-only', !isEditModeEnabled && note.type]">
  <gif-view [gifSize]="sizeOfGif.Small" [gif]="note.gif" [isResponsive]="true"></gif-view>
</div>
